import { useMemo } from 'react'
import addMonths from 'date-fns/addMonths'
import addDays from 'date-fns/addDays'
import isBefore from 'date-fns/isBefore'
import isSameDay from 'date-fns/isSameDay'

const useNextBusinessDate = (closedDates: Date[]): Date => {
  return useMemo(() => {
    const now = new Date()
    let nextBusinessDate = now
    // 無限ループを防ぐため1ヶ月先までチェック
    const oneMonthLater = addMonths(now, 1)
    for (let date = addDays(now, 1); isBefore(date, oneMonthLater); date = addDays(date, 1)) {
      if (closedDates.some((closedDate) => isSameDay(closedDate, date))) continue
      nextBusinessDate = date
      break
    }
    return nextBusinessDate
  }, [closedDates])
}

export default useNextBusinessDate
